import React from 'react'
import { connect } from 'react-redux'
import ListItem from 'material-ui/List/ListItem'
import Avatar from 'material-ui/Avatar'
import RaisedButton from 'material-ui/RaisedButton'
import Panel from 'muicss/lib/react/panel'
import Container from 'muicss/lib/react/container'
import Col from 'muicss/lib/react/col'
import Snackbar from 'material-ui/Snackbar'
import ReportDialog from './ReportDialog'
import ContactDialog from './ContactDialog'
const styles = {
  root: {
    fontFamily: 'Roboto, sans-serif',
  },
}

class Contact extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      contactOpen: false,
      reportOpen: false,
    }
  }

  handleSnackbarClose = () => {
    this.setState({ contactSnackbarOpen: false })
  }

  showSnackbar = () =>{
    this.setState({contactSnackbarOpen: true})
  }

  contactToggleOpen = () => {
    this.setState({
      contactOpen: !this.state.contactOpen,
    })
  }

  reportToggleOpen = () => {
    this.setState({
      reportOpen: !this.state.reportOpen,
    })
  }

  render() {
    const { image_url, first_name, last_name } = this.props
    return (
      <Container>
        <Panel className="modal-panel" style={styles.root}>
          <h1 style={{ textAlign: 'center' }}>Contáctanos</h1>
          <ListItem
            disabled
            leftAvatar={
              <Avatar
                src={image_url}
                size={40}
              />
            }
          >
            {`${first_name} ${last_name}`}
          </ListItem>
          <Col xs="12" md="6">
            <h2>Reportar problema:</h2>
            <ul>
              <li>¿No funciona la app?</li>
              <li>¿Encontraste alguna falla?</li>
              <li>¡Cuéntanos para ayudarte!</li>
            </ul>
            <RaisedButton
              label="Reportar"
              primary onTouchTap={this.reportToggleOpen}
            />
            <ReportDialog showSnackbar={this.showSnackbar} toggleOpen={this.reportToggleOpen} open={this.state.reportOpen} />
          </Col>
          <Col xs="12" md="6">
            <h2>Contacto General:</h2>
            <ul>
              <li>¿Aún no han revisado tu misión?</li>
              <li>¿Tienes alguna duda o sugerencia?</li>
              <li>¡Nos interesa mucho tu opinión!</li>
            </ul>
            <RaisedButton
              label="Contactar"
              onTouchTap={this.contactToggleOpen} primary
            />
            <ContactDialog showSnackbar={this.showSnackbar} toggleOpen={this.contactToggleOpen} open={this.state.contactOpen} />
          </Col>
        </Panel>
        <Snackbar
          open={this.state.contactSnackbarOpen}
          message={'Mensaje enviado correctamente.'}
          action={'OK'}
          autoHideDuration={1500}
          onRequestClose={this.handleSnackbarClose}
        />
      </Container>
    )
  }

}

Contact.propTypes = {
  image_url: React.PropTypes.string.isRequired,
  first_name: React.PropTypes.string.isRequired,
  last_name: React.PropTypes.string.isRequired,
}

const mapStateToProps = state => ({ ...state.user })

const mapDispatchToProps = () => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(Contact)



// WEBPACK FOOTER //
// ./src/components/Contact/index.jsx